<template>
  <res-select ref="selector" :id="elementId" :attach="attachId" :readonly="readonly" v-model="selectedTemplate" :items="templates" :menuProps="menuProps" :loading="loading" return-object :placeholder="'select'"></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import settingsTemplateService from '@/services/settings-template';

  export default {
    name: 'AllPropsSettingsTemplateSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        templates: [],
        loading: true,
      }
    },
    props: {
      value: {
        required: true
      },
      elementId: {
        type: String,
        default: "settings-template-selector"
      },
      readonly: {
        type: Boolean,
        default: false
      },
      menuProps: {
        default: () => {}
      },
    },
    methods: {
      async loadTemplates() {
        this.loading = true;
          let templateData = await settingsTemplateService.getDropdown();
          if (templateData && templateData.data) {
            this.templates = templateData.data;
            if (this.value) {
              this.templates.forEach((template) => {
                if (this.value.toLowerCase() == template.value.toLowerCase()) {
                  this.selectItem(template);
                }
              });
            }
        } else {
          this.templates = [];
        }
        this.loading = false;
      },
      selectItem(item) {
        this.$refs.selector.selectItem(item)
      }
    },
    computed: {
      selectedTemplate: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      attachId() {
        return '#' + this.elementId;
      },
    },
    async mounted() {
      await this.loadTemplates();
    }
  }
</script>
